import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {UserService} from "./services/user.service";
import {HeaderComponent} from './components/header/header.component';
import {FooterComponent} from './components/footer/footer.component';
import {ModalPrivacyPolicyComponent} from './modals/modal-privacy-policy/modal-privacy-policy.component';
import {FeedbackReportButtonComponent} from './components/feedback-report-button/feedback-report-button.component';
import {ToastNotificationComponent} from './utility/toast-notification/toast-notification.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [HeaderComponent, ModalPrivacyPolicyComponent, RouterOutlet, FooterComponent, FeedbackReportButtonComponent, ToastNotificationComponent]
})
export class AppComponent {
  title = 'Decisions Frontend';
  constructor(public userService: UserService) {
  }


  ngOnInit() {

    //  fix per impostare lo scale del viewport solo se il dispositivo ha una risoluzione inferiore a 768
    if (window.innerWidth < 768) {
      let viewport = document.querySelector("meta[name=viewport]");
      let content = "width=device-width, initial-scale=1.0";
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport['name'] = "viewport";
        viewport.setAttribute('content', content);
        document.getElementsByTagName('head')[0].appendChild(viewport);
      } else {
        content = "width=768, initial-scale=2.0";
        viewport.setAttribute('content', content);
      }
    }
  }
}
